import { type Websocket } from 'entities/WebSocket/store'

interface IEventUserProps {
  id: number | string
}

export class ChannelUserConversation {
  privateChannelName: string
  presenceChannelName: string

  constructor(props: IEventUserProps, private _websocket: Websocket) {
    this.privateChannelName = `private-user.${props.id}.conversation`
    this.presenceChannelName = `presence-user.${props.id}.conversation`

    this.subscribe()
  }

  subscribe() {
    this._websocket.subscribe(this.privateChannelName)
    this._websocket.subscribe(this.presenceChannelName)
  }
}
